import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

jQuery(($) => {
	if ($(".swiperTwoColumns").length > 0) {
		var slideCount = $(".two-columns-slider .swiper-wrapper .slide").length;

		if (slideCount < 2) {
			$(".two-columns-slider").addClass("only-one");
		}

		const swiperTwoColumns = new Swiper(".swiperTwoColumns", {
			loop: true,
			/*centeredSlides: true,
			autoHeight: true,
			allowSlideNext: false,
			spaceBetween: 0,
			slidesPerView: 1,
			*/
			allowTouchMove: false,
			navigation: {
				nextEl: ".swiper-button-next-two-columns",
				prevEl: ".swiper-button-prev-two-columns",
			},
			pagination: {
				el: ".swiper-pagination-two-columns",
				clickable: true,
			},
			modules: [Navigation, Pagination],
		});
	}
});

/*

import { Navigation, Autoplay } from "swiper/modules";

autoplay: {
	delay: 5000,
	disableOnInteraction: true,
	pauseOnMouseEnter: true,
},


			modules: [Navigation, Autoplay],

			*/
